import { messengerHttp, messengerError } from "@/helpers/messengerHttp";

// บรอดแคสต์: proship-messenger broadcast API. Callback style like messenger.js:
// payload.callback(true, data) or payload.callback(false, {status, code, detail, messageTh, body}).
// messageTh is the Thai line the API sends with every error: show it, never the code.
// State stays empty (vuex-persist would write seller data to localStorage).
const done = (payload, ok, data) => {
  if (payload && payload.callback) payload.callback(ok, data);
};

const failure = (err) => {
  const base = messengerError(err);
  const data = (err && err.response && err.response.data) || {};
  const headers = (err && err.response && err.response.headers) || {};
  return Object.assign({}, base, {
    retryAfter: parseInt(headers["retry-after"], 10) || 0,
    messageTh: typeof data.messageTh === "string" ? data.messageTh : null,
    body: typeof data === "object" ? data : {}, // extra fields: pages[], remainingToday, ...
  });
};

// .then(onOk, onFail), not .catch: an error inside a success callback is not reported as an API failure
const settle = (request, payload, pick) =>
  request.then(
    (response) => {
      const data = (response && response.data) || {};
      if (data.success === false) return done(payload, false, failure({ response }));
      done(payload, true, pick ? pick(data) : data);
    },
    (err) => done(payload, false, failure(err))
  );

const enc = encodeURIComponent;

const idList = (ids) => (Array.isArray(ids) ? ids : [ids]).filter((id) => id != null && id !== "").map(String).join(",");

// Only the keys the caller set, so the API sees no "undefined" query values
const query = (obj) => {
  const params = {};
  Object.keys(obj).forEach((key) => {
    if (obj[key] != null && obj[key] !== "") params[key] = obj[key];
  });
  return params;
};

const broadcastPath = (id) => "/api/broadcasts/" + enc(id);

export default {
  namespaced: true,
  state: {},
  actions: {
    // {state: ready|reconnect|connect|closed, ...}
    fetchGate(context, payload) {
      settle(messengerHttp.get("/api/broadcast/gate"), payload);
    },

    // The Page picker: each Page, whether it can send and why not, sync chip, shop
    fetchPages(context, payload) {
      settle(messengerHttp.get("/api/broadcast/pages"), payload);
    },

    fetchTemplates(context, payload) {
      settle(messengerHttp.get("/api/broadcast/templates"), payload);
    },

    // payload: {pageIds: [..], text}. The seller's own utility template, starts pending.
    createTemplate(context, payload) {
      settle(messengerHttp.post("/api/broadcast/templates", { pageIds: payload.pageIds, text: payload.text }), payload);
    },

    // payload.body: {kind, groups, pageIds, message | templateKey | templateId, slots, idempotencyKey}
    createBroadcast(context, payload) {
      settle(messengerHttp.post("/api/broadcasts", payload.body, { timeout: 60000 }), payload);
    },

    // payload: {id, phone}
    testBroadcast(context, payload) {
      settle(messengerHttp.post(broadcastPath(payload.id) + "/test", { phone: payload.phone }), payload);
    },

    startBroadcast(context, payload) {
      settle(messengerHttp.post(broadcastPath(payload.id) + "/start"), payload);
    },

    pauseBroadcast(context, payload) {
      settle(messengerHttp.post(broadcastPath(payload.id) + "/pause"), payload);
    },

    resumeBroadcast(context, payload) {
      settle(messengerHttp.post(broadcastPath(payload.id) + "/resume"), payload);
    },

    cancelBroadcast(context, payload) {
      settle(messengerHttp.post(broadcastPath(payload.id) + "/cancel"), payload);
    },

    // payload: {cursor?} -> {rows, next}
    fetchBroadcasts(context, payload) {
      settle(messengerHttp.get("/api/broadcasts", { params: query({ cursor: payload && payload.cursor }) }), payload);
    },

    // payload: {id}
    fetchBroadcast(context, payload) {
      settle(messengerHttp.get(broadcastPath(payload.id)), payload);
    },

    // The group counts of step 2. payload: {kind: window|utility, pageIds: [..]}
    // -> {counts: {tracked, ordered, interested, one_message, all}, approx}
    fetchCounts(context, payload) {
      settle(
        messengerHttp.get("/api/broadcast/counts", { params: { kind: payload.kind, pageIds: idList(payload.pageIds) } }),
        payload
      );
    },

    // ลูกค้าที่เคยทักมา. payload: {pageIds: [..], group?: ordered|interested|one_message|all, q?, cursor?, limit?}
    fetchCustomers(context, payload) {
      const params = query({
        pageIds: idList(payload.pageIds),
        group: payload.group,
        q: payload.q,
        cursor: payload.cursor,
        limit: payload.limit,
      });
      settle(messengerHttp.get("/api/broadcast/customers", { params }), payload);
    },

    // payload: {pageIds} -> {total, ordered, interested, one_message, window24h, tracked, approx, sync: [..]}
    fetchCustomersSummary(context, payload) {
      settle(
        messengerHttp.get("/api/broadcast/customers/summary", { params: { pageIds: idList(payload.pageIds) } }),
        payload
      );
    },

    // payload: {customerId, pageId} -> {customer, messages, inboxUrl}
    fetchCustomerMessages(context, payload) {
      settle(
        messengerHttp.get("/api/broadcast/customers/" + enc(payload.customerId) + "/messages", {
          params: { pageId: payload.pageId },
        }),
        payload
      );
    },
  },
};

